import { createAction, createReducer } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";

// enable hash-map for state mutation copy by immer
enableMapSet();

const initialState = {
  skus: new Map(),
  bundles: new Map(),
  size: 0,
};

export const updateCart = createAction("cart/updateCart");
export const setCart = createAction("cart/setCart");
export const clearCart = createAction("cart/clearCart");

const cartReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setCart, (state, action) => {
      // reset cart before setting new one
      state.skus.clear();
      state.bundles.clear();
      // start setting new one
      const { skus, bundles, cartSize } = action.payload;
      skus.forEach((sku) => {
        state.skus.set(sku.id, sku.quantity);
      });
      bundles.forEach((bundle) => {
        state.bundles.set(bundle.id, {
          quantity: bundle.quantity,
          canAddMore: bundle.canAddMore,
        });
        bundle.skus.forEach((sku) => {
          state.skus.set(
            sku.id,
            (state.skus.get(sku.id) || 0) + bundle.quantity * sku.quantity
          );
        });
      });
      state.size = cartSize;
    })
    .addCase(updateCart, (state, action) => {
      const { skus, bundles, cartSize } = action.payload;
      skus.forEach((sku) => {
        const newQuantity = (state.skus.get(sku.id) || 0) + sku.quantity;
        if (newQuantity === 0) {
          state.skus.delete(sku.id);
        } else {
          state.skus.set(sku.id, newQuantity);
        }
      });
      bundles.forEach((bundle) => {
        const newBundleQuantity =
          (state.bundles.get(bundle.id)?.quantity || 0) + bundle.quantity;
        if (newBundleQuantity === 0) {
          state.bundles.delete(bundle.id);
        } else {
          state.bundles.set(bundle.id, {
            canAddMore: bundle.canAddMore,
            quantity: newBundleQuantity,
          });
        }
        bundle.skus.forEach((sku) => {
          const newSkuQuantity =
            (state.skus.get(sku.id) || 0) + bundle.quantity * sku.quantity;
          if (newSkuQuantity === 0) {
            state.skus.delete();
          } else {
            state.skus.set(sku.id, newSkuQuantity);
          }
        });
      });
      state.size = cartSize;
    })
    .addCase(clearCart, (state) => {
      state.skus.clear();
      state.bundles.clear();
      state.size = 0;
    });
});

export default cartReducer;

export const selectIsSkuInCart = (state, skuId) =>
  state.cart.skus.get(skuId) ? true : false;

export const selectIsBundleInCart = (state, bundleId) =>
  state.cart.bundles.get(bundleId) ? true : false;

export const selectCartSkuQuantity = (state, skuId) =>
  state.cart.skus.get(skuId) || 0;

export const selectCartBundleQuantity = (state, bundleId) =>
  state.cart.bundles.get(bundleId)?.quantity || 0;

export const selectIsBundleCanAddMore = (state, bundleId) =>
  state.cart.bundles.get(bundleId)?.canAddMore || false;

export const selectBundle = (state, bundleId) =>
  state.cart.bundles.get(bundleId);
export const selectCartSize = (state) => state.cart.size;
export const selectCartSkus = (state) => state.cart.skus;
